export const redirectToLogin = () => {
  window.location.replace('/users/login');
};



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/notifications/helpers.js